module.exports = __webpack_public_path__ + "img/ic_no_skills.dcbdb901.png";